import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HashRedirector = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Remove the # symbol from the URL
      const cleanPath = hash.substring(1);
      // Redirect to the clean URL
      navigate(cleanPath, { replace: true });
    }
  }, [navigate]);

  return null;
};

export default HashRedirector;
